import { render, staticRenderFns } from "./dialogue.vue?vue&type=template&id=8a84e2dc&scoped=true&"
import script from "./dialogue.vue?vue&type=script&lang=js&"
export * from "./dialogue.vue?vue&type=script&lang=js&"
import style0 from "./dialogue.vue?vue&type=style&index=0&id=8a84e2dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a84e2dc",
  null
  
)

export default component.exports